import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import SeasonSelect from "../SeasonSelect";
import {useTranslation} from "react-i18next";

export const useToolbar = (availableSeasons) => {
    const sortedSeason = availableSeasons.sort((a, b) => b - a);

    const [selectedSeason, setSelectedSeason] = useState(sortedSeason?.[0] ?? null);
    const [historyFrom, setHistoryFrom] = useState(sortedSeason?.[sortedSeason.length - 1] ?? null)
    const [historyTo, setHistoryTo] = useState(sortedSeason?.[1] ?? null);
    const [compareWith, setCompareWith] = useState(null);

    useEffect(() => {
        setSelectedSeason(sortedSeason?.[0] ?? null);
        setHistoryFrom(sortedSeason?.[sortedSeason.length - 1] ?? null);
        setHistoryTo(sortedSeason?.[1] ?? null);
    }, [availableSeasons]);

    return {
        selectedSeason,
        setSelectedSeason,
        historyFrom,
        setHistoryFrom,
        historyTo,
        setHistoryTo,
        compareWith,
        setCompareWith
    }
}

const Toolbar = (props) => {
    const {t} = useTranslation("graphs");
    const {
        selectedSeason,
        setSelectedSeason,
        historyFrom,
        setHistoryFrom,
        historyTo,
        setHistoryTo,
        compareWith,
        setCompareWith,
        availableSeasons
    } = props;

    return <Grid container sx={{py: 4}}>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={selectedSeason}
                          setSelectedSeason={setSelectedSeason}
                          sx={{minWidth: "9rem"}}
                          label={t("hsGraph.season")}
                          availableSeasons={availableSeasons}
            />
        </Grid>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={historyFrom}
                          setSelectedSeason={setHistoryFrom}
                          sx={{minWidth: "9rem"}}
                          label={t("hsGraph.historyFrom")}
                          availableSeasons={availableSeasons}
            />
        </Grid>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={historyTo}
                          setSelectedSeason={setHistoryTo}
                          sx={{minWidth: "9rem"}}
                          label={t("hsGraph.historyTo")}
                          availableSeasons={availableSeasons}
                          optionsFrom={historyFrom}
            />
        </Grid>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={compareWith}
                          setSelectedSeason={setCompareWith}
                          sx={{minWidth: "9rem"}}
                          label={t("hsGraph.compareWith")}
                          availableSeasons={availableSeasons}
                          allowEmpty
            />
        </Grid>
    </Grid>
}

export default Toolbar;